import { useChapterStore } from '../../../shared/store/useChapterStore';
import icon from '@/assets/downloadable-content.png';

export const DownloadLinks = () => {
  const chapter = useChapterStore((state) => state.chapter);

  if (!chapter || !chapter?.downloadArea?.downloadLink?.length) return null;

  return (
    <div className="rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5">
      {chapter?.downloadArea?.header && (
        <div className="mb-sh-15 flex items-center gap-sh-15">
          {chapter.downloadArea.header.icon?.url && (
            <img src={chapter.downloadArea.header.icon.url} alt="" className="size-[38px]" />
          )}
          <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{chapter.downloadArea.header.title}</h3>
        </div>
      )}
      {chapter?.downloadArea?.downloadLink?.map((link) => {
        if (!link) return null;
        return (
          <li key={link?.title} className="flex flex-col !pb-4 pl-0 text-sh-sm last:!pb-0">
            <a
              href={link?.content?.url}
              rel="noreferrer"
              target="_blank"
              className="flex items-center font-bold text-black-100">
              <img src={icon} className="mr-1" alt="downloadable icon" />
              {link?.title}
            </a>
            <ol className="!m-0 !pl-6 text-sh-xxs">{link?.description}</ol>
          </li>
        );
      })}
    </div>
  );
};
